export default class alarmCenter {
    constructor(){

    }
    getHisFileList(){
        
    }
}


// WEBPACK FOOTER //
// ./src/js/backstage/fvVideoServer/index.js